module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/paragraph-8df6047ca18666af7db0aa52ef489292.svg";